import * as SS from 'styled-system'

const displayFlex = {
  display: 'flex',
}
const flexCenter = {
  alignItems: 'center',
  justifyContent: 'center',
}

export interface IFlexibleStyles {
  column: any
  'column-center': any
  'column-v-center': any
  'column-h-start': any
  'column-h-end': any
  'column-h-center': any
  'column-v-end': any
  'column-space-between': any
  row: any
  'row-wrap': any
  'row-center': any
  'row-v-center': any
  'row-v-end': any
  'row-h-center': any
  'row-h-end': any
  'row-h-end-wrap': any
  'row-space-between': any
  'row-space-between-wrap': any
  'row-space-around': any
  'row-space-around-wrap': any
}

export const flexibleStyles: IFlexibleStyles = {
  column: {
    ...displayFlex,
    flexDirection: 'column',
  },
  'column-center': {
    ...displayFlex,
    ...flexCenter,
    flexDirection: 'column',
  },
  'column-v-center': {
    ...displayFlex,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  'column-h-start': {
    ...displayFlex,
    alignItems: 'flex-start',
    flexDirection: 'column',
  },
  'column-h-end': {
    ...displayFlex,
    alignItems: 'flex-end',
    flexDirection: 'column',
  },
  'column-h-center': {
    ...displayFlex,
    flexDirection: 'column',
    alignItems: 'center',
  },
  'column-v-end': {
    ...displayFlex,
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
  },
  'column-space-between': {
    ...displayFlex,
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  row: {
    ...displayFlex,
    flexDirection: 'row',
  },
  'row-wrap': {
    ...displayFlex,
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  'row-center': {
    ...displayFlex,
    ...flexCenter,
    flexDirection: 'row',
  },
  'row-v-center': {
    ...displayFlex,
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexDirection: 'row',
  },
  'row-v-end': {
    ...displayFlex,
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
    flexDirection: 'row',
  },
  'row-h-center': {
    ...displayFlex,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  'row-h-end': {
    ...displayFlex,
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  'row-h-end-wrap': {
    ...displayFlex,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
  },
  'row-space-between': {
    ...displayFlex,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  'row-space-between-wrap': {
    ...displayFlex,
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  'row-space-around': {
    ...displayFlex,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
  },
  'row-space-around-wrap': {
    ...displayFlex,
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-around',
  },
}

export default SS.variant({
  key: 'flexibleStyles',
  prop: 'flexible',
})
